import * as Types from '../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type FormCustomComponentFormListByEventIdQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type FormCustomComponentFormListByEventIdQuery = { __typename?: 'Query'; formListByEventId: Array<{ __typename?: 'Form'; id: string; title: string; description: string }> };

export type FormCustomComponentFormByIdQueryVariables = Types.Exact<{
  formId: Types.Scalars['ID'];
}>;

export type FormCustomComponentFormByIdQuery = {
  __typename?: 'Query';
  formById?: { __typename?: 'Form'; id: string; title: string; description: string; schemaUrl: string; config: any; eventId?: string | null; type?: Types.FormType | null } | null;
};

export type FormCustomComponentSubmitFormAnswersMutationVariables = Types.Exact<{
  input: Types.SubmitFormAnswersInput;
}>;

export type FormCustomComponentSubmitFormAnswersMutation = {
  __typename?: 'Mutation';
  submitFormAnswers: { __typename?: 'Form'; id: string; eventId?: string | null; title: string };
};

export const FormCustomComponentFormListByEventIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormCustomComponentFormListByEventId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formListByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFormCustomComponentFormListByEventIdQuery__
 *
 * To run a query within a React component, call `useFormCustomComponentFormListByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCustomComponentFormListByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCustomComponentFormListByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFormCustomComponentFormListByEventIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>(
    FormCustomComponentFormListByEventIdDocument,
    baseOptions,
  );
}
export function useFormCustomComponentFormListByEventIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>(
    FormCustomComponentFormListByEventIdDocument,
    baseOptions,
  );
}
export type FormCustomComponentFormListByEventIdQueryHookResult = ReturnType<typeof useFormCustomComponentFormListByEventIdQuery>;
export type FormCustomComponentFormListByEventIdLazyQueryHookResult = ReturnType<typeof useFormCustomComponentFormListByEventIdLazyQuery>;
export type FormCustomComponentFormListByEventIdQueryResult = Apollo.QueryResult<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>;
export const FormCustomComponentFormByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormCustomComponentFormById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'config' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFormCustomComponentFormByIdQuery__
 *
 * To run a query within a React component, call `useFormCustomComponentFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCustomComponentFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCustomComponentFormByIdQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormCustomComponentFormByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>(FormCustomComponentFormByIdDocument, baseOptions);
}
export function useFormCustomComponentFormByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>(FormCustomComponentFormByIdDocument, baseOptions);
}
export type FormCustomComponentFormByIdQueryHookResult = ReturnType<typeof useFormCustomComponentFormByIdQuery>;
export type FormCustomComponentFormByIdLazyQueryHookResult = ReturnType<typeof useFormCustomComponentFormByIdLazyQuery>;
export type FormCustomComponentFormByIdQueryResult = Apollo.QueryResult<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>;
export const FormCustomComponentSubmitFormAnswersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FormCustomComponentSubmitFormAnswers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmitFormAnswersInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitFormAnswers' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FormCustomComponentSubmitFormAnswersMutationFn = Apollo.MutationFunction<
  FormCustomComponentSubmitFormAnswersMutation,
  FormCustomComponentSubmitFormAnswersMutationVariables
>;

/**
 * __useFormCustomComponentSubmitFormAnswersMutation__
 *
 * To run a mutation, you first call `useFormCustomComponentSubmitFormAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCustomComponentSubmitFormAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCustomComponentSubmitFormAnswersMutation, { data, loading, error }] = useFormCustomComponentSubmitFormAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormCustomComponentSubmitFormAnswersMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<FormCustomComponentSubmitFormAnswersMutation, FormCustomComponentSubmitFormAnswersMutationVariables>,
) {
  return ApolloReactHooks.useMutation<FormCustomComponentSubmitFormAnswersMutation, FormCustomComponentSubmitFormAnswersMutationVariables>(
    FormCustomComponentSubmitFormAnswersDocument,
    baseOptions,
  );
}
export type FormCustomComponentSubmitFormAnswersMutationHookResult = ReturnType<typeof useFormCustomComponentSubmitFormAnswersMutation>;
export type FormCustomComponentSubmitFormAnswersMutationResult = Apollo.MutationResult<FormCustomComponentSubmitFormAnswersMutation>;
export type FormCustomComponentSubmitFormAnswersMutationOptions = Apollo.BaseMutationOptions<
  FormCustomComponentSubmitFormAnswersMutation,
  FormCustomComponentSubmitFormAnswersMutationVariables
>;
